import React from 'react';

import Loader from 'components/Loader';

const TranslationsLoader: React.FC = () => <Loader label="Trwa pobieranie danych" />;

export default TranslationsLoader;
